import { render, staticRenderFns } from "./category-wrapper.html?vue&type=template&id=a5fe27a2&scoped=true&external"
import script from "./category-wrapper.js?vue&type=script&lang=js&external"
export * from "./category-wrapper.js?vue&type=script&lang=js&external"
import style0 from "./category-wrapper.scss?vue&type=style&index=0&id=a5fe27a2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fe27a2",
  null
  
)

export default component.exports